import { Component } from '@angular/core';
import {ModalsService} from "../../services/modals.service";

@Component({
  selector: 'app-ugc-uploaded-modal',
  templateUrl: './ugc-uploaded-modal.component.html',
  styleUrls: ['./ugc-uploaded-modal.component.css']
})
export class UgcUploadedModalComponent {

  constructor(private readonly modalsService: ModalsService) {
  }

  close(): void {
    this.modalsService.hideModal();
  }
}
